import { render, staticRenderFns } from "./CompsModal.vue?vue&type=template&id=90ba8e18&scoped=true"
import script from "./compsModal.ts?vue&type=script&lang=ts&external"
export * from "./compsModal.ts?vue&type=script&lang=ts&external"
import style0 from "./CompsModal.vue?vue&type=style&index=0&id=90ba8e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba8e18",
  null
  
)

export default component.exports